import { withNaming } from '@bem-react/classname';

export const classNames = withNaming({ e: '__', m: '_', v: '_' });
